import { render, staticRenderFns } from "./FormRFQ3.vue?vue&type=template&id=c2cc2210&"
import script from "./FormRFQ3.vue?vue&type=script&lang=js&"
export * from "./FormRFQ3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports